module.exports = __webpack_public_path__ + "img/logo-chc.1a042f72.png";